import type { ViewQueryRecordNode } from '@salescore/core'
import { Result } from 'effect'

import { getRecordNodeFromRootNodePure } from '../../state/nodeUtility'
import type { DeepReadonly } from '../types/DeepReadonly'

export interface GetChildRecordLeft {
  message: 'ノードパスが不正です' | 'ノードが見つかりませんでした'
}

export const getChildRecord = (
  rootNode: DeepReadonly<ViewQueryRecordNode>,
  nodePath: DeepReadonly<string[]>,
  childRecordId: string,
): Result.Result<ViewQueryRecordNode, GetChildRecordLeft> => {
  if (nodePath.length < 2) {
    return Result.fail({ message: 'ノードパスが不正です' })
  }
  const siblings = getRecordNodeFromRootNodePure(rootNode, nodePath)
  if (siblings === undefined || !Array.isArray(siblings)) {
    return Result.fail({ message: 'ノードが見つかりませんでした' })
  }
  const childRecord = siblings.find((record) => record.id === childRecordId)
  if (childRecord === undefined) {
    return Result.fail({ message: 'ノードが見つかりませんでした' })
  }
  return Result.succeed(childRecord)
}
